<div class="container">
  @if (!sessionsView) {
    <button
      class="margin--right-m"
      mat-flat-button
      color="primary"
      [routerLink]="['/payment-terminals/payter/sessions']"
      [admRequiresFeatureRole]="roles['payter-payment-terminal.read']">
      <span class="material-symbols-outlined"> battery_charging_{{ batteryIconState }} </span>
      Ladesessioner
    </button>
  }
  @if (sessionsView) {
    <button mat-button [routerLink]="['/payment-terminals/payter']" [admRequiresFeatureRole]="roles['payter-payment-terminal.read']">
      <mat-icon>list</mat-icon>
      Tilbage til terminal oversigt
    </button>
  }
</div>
